import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { IonicModule } from '@ionic/angular';

import { BaseTranslateModule } from '@nx-ahs/base-translate';

import { MaintenanceComponent } from './maintenance.component';
import { LayoutModule } from '../../../shared/components/layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

const routes: Routes = [
	{
		path: '',
		component: MaintenanceComponent
	}
];

@NgModule({
	imports: [
		CommonModule,
		IonicModule,
		MatCardModule,
		MatFormFieldModule,
		MatIconModule,
		RouterModule.forChild(routes),
		FlexLayoutModule,
		LayoutModule,
		BaseTranslateModule,
		TranslateModule,
		LayoutModule,
		FontAwesomeModule,
		FlexLayoutModule
	],
	declarations: [MaintenanceComponent],
	exports: [MaintenanceComponent]
})
export class MaintenancePageModule {}
